import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

export const ReactQueryClientWrapper = () => {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  });

  return ({ children }: PropsWithChildren) => (
    <QueryClientProvider client={client}>{children}</QueryClientProvider>
  );
};
